import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { useState } from 'react';
import { useAsyncFn } from 'react-use';
import { unreachable } from './utils';
export const useStreamPrediction = _ref => {
  let {
    aiApiClient,
    assistantId,
    conversationId,
    exerciseId,
    messageContent,
    modelTag,
    poweredBy,
    setConversation,
    systemPrompt
  } = _ref;
  const isNotPoweredByOpenAI = poweredBy.poweredByType !== 'OpenAI';
  const triggerTag = assistantId != null ? 'campusUserAssistant' : 'campusUserConversation';
  const [error, setError] = useState(undefined);
  const [state, getPrediction] = useAsyncFn(async () => {
    try {
      const response = await aiApiClient.generateConversationPrediction({
        body: {
          assistantId,
          conversationId,
          input: {
            isNotPoweredByOpenAI,
            systemPrompt
          },
          message: {
            content: messageContent,
            role: 'user'
          },
          shouldStream: true,
          trigger: {
            _tag: triggerTag,
            exerciseId
          }
        },
        params: {
          modelTag
        }
      });
      if ((response === null || response === void 0 ? void 0 : response.status) === 429) {
        setError({
          type: 'rate-limit-error'
        });
        return;
      }
      if ((response === null || response === void 0 ? void 0 : response.body) != null && response.ok) {
        const reader = response.body.getReader();

        // eslint-disable-next-line no-constant-condition
        while (true) {
          // eslint-disable-next-line no-await-in-loop
          const {
            done,
            value
          } = await reader.read();

          // Stream is done, use previousValue to determine exit type
          if (done) {
            break;
          }
          if (value) {
            const lines = new TextDecoder('utf-8').decode(value).split('\n');
            lines.forEach(line => {
              if (line.trim() !== '') {
                const gptStream = JSON.parse(line);
                if (gptStream.type === 'gpt-error') {
                  setError({
                    reason: gptStream.reason,
                    type: 'gpt-stream-error'
                  });
                  return;
                }
                switch (gptStream.type) {
                  case 'gpt-conversation-id':
                    {
                      // Update the conversationId
                      setConversation(prevConversation => {
                        return _objectSpread(_objectSpread({}, prevConversation), {}, {
                          conversationId: gptStream.conversationId
                        });
                      });
                      break;
                    }
                  case 'gpt-id':
                    // Add an empty assistant message to the conversation
                    setConversation(prevConversation => {
                      return _objectSpread(_objectSpread({}, prevConversation), {}, {
                        messages: [...prevConversation.messages, {
                          aiModelPredictionOutputId: gptStream.id,
                          content: '',
                          loading: false,
                          role: 'assistant'
                        }]
                      });
                    });
                    break;
                  case 'gpt-partial-answer':
                    // Update the last message in the conversation
                    setConversation(prevConversation => {
                      const lastMessage = prevConversation.messages[prevConversation.messages.length - 1];
                      return _objectSpread(_objectSpread({}, prevConversation), {}, {
                        messages: [...prevConversation.messages.slice(0, prevConversation.messages.length - 1), _objectSpread(_objectSpread({}, lastMessage), {}, {
                          content: "".concat(lastMessage.content).concat(gptStream.choices[0].text)
                        })]
                      });
                    });
                    break;
                  default:
                    unreachable(gptStream);
                }
              }
            });
          }
        }
      } else {
        setError({
          type: 'unknown-error'
        });
      }
    } catch (err) {
      setError({
        type: 'unknown-error'
      });
    }
  }, [messageContent]);
  return {
    error,
    getPrediction,
    loading: state.loading
  };
};